import { Identidad } from "./identidad.model";

export class Empresa {
  identidad = Identidad.instance();
  digitoVerificador: string;
  razonSocial: string;
  correoElectronico: string

  static instance() {
    return new this();
  }

  static empleadorDesdeObj(obj: object) {
    const empresaDto = Empresa.instance();
    empresaDto.identidad = {
      tipo: obj["tipoIdEmpleador"] || obj["tipoDocumento"] ,
      numero: obj["idEmpleador"] || obj["numeroDocumento"].slice(0, -1)
    };
    empresaDto.digitoVerificador = obj["digVerifEmpleador"] ?? obj["numeroDocumento"]?.slice(-1);
    if(empresaDto.digitoVerificador == null || empresaDto.digitoVerificador == "null" || empresaDto.digitoVerificador == undefined ){
      empresaDto.digitoVerificador = "";
    }

    if (`${obj["nombre"]}` == 'null') {
      console.log("No se encontró razon social de empresa");
      return;
    }
    empresaDto.razonSocial = `${obj["nombre"]}`;
      empresaDto.correoElectronico = obj["correoEmpleador"] ?? obj["correoElectronico"];

    return empresaDto;
  }

  static empleadorDesdeObjRIT(obj: object, nitEmpresa?: string, checkDigit?: string) {
    const empresaDto = Empresa.instance();
    empresaDto.identidad = {
      tipo: `${obj["tipoDocumento"]}`,
      numero: `${obj["numeroDocumento"]}`,
    }
    const numeroDocumento = `${obj["digitoVerificador"]!=null || obj["digitoVerificador"]!="null" ? obj["digitoVerificador"]:""}`;
    empresaDto.digitoVerificador = numeroDocumento.slice(-1);
    if(empresaDto.digitoVerificador == null || empresaDto.digitoVerificador == "null" || empresaDto.digitoVerificador == undefined ){
      empresaDto.digitoVerificador = "";
    }
    empresaDto.razonSocial = `${obj["nombre"]}`;
    empresaDto.correoElectronico = `${obj["correoElectronico"]}`;
    return empresaDto;
  }

  static empleadorDesdeObjRBT(obj: object, nitEmpresa?: string, checkDigit?: string) {
    const empresaDto = Empresa.instance();
    empresaDto.identidad = {
      tipo: `${obj["tipoDocumento"]}`,
      numero: nitEmpresa,
    }
    empresaDto.digitoVerificador = checkDigit
    if(empresaDto.digitoVerificador == null || empresaDto.digitoVerificador == "null" || empresaDto.digitoVerificador == undefined ){
      empresaDto.digitoVerificador = "";
    }
    empresaDto.razonSocial = `${obj["nombre"]}`;
    empresaDto.correoElectronico = `${obj["correoElectronico"]}`;
    return empresaDto;
  }

  static empleadorDesdeObjCEC(obj: object, nitEmpresa: string, checkDigit: string) {
    const empresaDto = Empresa.instance();
    empresaDto.identidad = {
      tipo: `${obj["tipoDocumento"]}`,
      numero: nitEmpresa.toString()
    }
    empresaDto.digitoVerificador = checkDigit.toString();
    if(empresaDto.digitoVerificador == null || empresaDto.digitoVerificador == "null" || empresaDto.digitoVerificador == undefined ){
      empresaDto.digitoVerificador = "";
    }
    empresaDto.razonSocial = `${obj["nombre"]}`;
    empresaDto.correoElectronico = `${obj["correoElectronico"]}`;
    return empresaDto;
  }
}
